module.exports = __webpack_public_path__ + "assets/img/scenic_17.5377f247.svg";